import PropTypes from 'prop-types';
import React from 'react';
import * as rmd from 'material-ui';
import { connect } from 'react-redux';
import auth from '../auth';
import { USER_ACTIONS } from '../reducers/user';

class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    static contextTypes = {
        router: PropTypes.object.isRequired,
    };

    handleLogin = e => {
        if (e.type === 'click' || (e.type === 'keypress' && e.charCode === 13)) {
            return fetch('/api/v2/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    username: this.state.username,
                    password: this.state.password,
                }),
            })
                .then(response => {
                    if (response.ok) {
                        return response.json().then(({ token, user }) => {
                            auth.saveUser(user);
                            auth.saveAccessToken(token);
                            this.props.dispatch({ type: USER_ACTIONS.LOGIN, payload: user });
                            this.context.router.push('/home');
                        });
                    } else {
                        this.setState({ error: ' ' });
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        }
    };

    render() {
        return (
            <div className="wrap">
                <div className="form-content">
                    <rmd.Card className="loginform">
                        <rmd.CardMedia>
                            <img src="https://www.getmdl.io/assets/demos/welcome_card.jpg" alt="login" />
                        </rmd.CardMedia>
                        <rmd.CardText>
                            <rmd.TextField
                                value={this.state.username || ''}
                                onChange={e => this.setState({ username: e.target.value })}
                                errorText={this.state.error}
                                onKeyPress={this.handleLogin}
                                style={{ width: '100%' }}
                                floatingLabelText="User name"
                            />
                            <rmd.TextField
                                type="password"
                                value={this.state.password || ''}
                                onChange={e => this.setState({ password: e.target.value })}
                                errorText={this.state.error}
                                onKeyPress={this.handleLogin}
                                style={{ width: '100%' }}
                                floatingLabelText="Password"
                            />
                        </rmd.CardText>
                        <rmd.CardActions className="actions">
                            <rmd.RaisedButton label="Login" primary onClick={this.handleLogin} />
                            {/*<rmd.RaisedButton label="Sign up" />*/}
                        </rmd.CardActions>
                    </rmd.Card>
                </div>
            </div>
        );
    }
}

export default connect()(LoginForm);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/LoginForm.js
 **/